import { render, staticRenderFns } from "./OrgPickerConfig.vue?vue&type=template&id=def7cafc&scoped=true"
import script from "./OrgPickerConfig.vue?vue&type=script&lang=js"
export * from "./OrgPickerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def7cafc",
  null
  
)

export default component.exports